import { atom } from 'jotai';
import { Key } from 'react-aria-components';

export const presetAtom = atom<Key>('custom');
